import styled from 'styled-components';

export const Action = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 0.75rem;
  border-radius: 0.25rem;
  padding: 0.25rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 500;
  border: ${props => props?.copied ? '1px solid #28a745' : '1px solid #ff7417'};
  color: ${props => props?.copied ? '#28a745' : '#ff7417'};
  background-color: transparent;
  cursor: pointer;
`;